import * as React from "react";
import { styled } from "styled-components";

import { Table } from "affinityUI/data/table";
import { UnitGranulocyte, UnitWBC } from "components/views/patientDetails/ui/resultUnits";
import { typeScale } from "lib/themeUtils";
import type { PatientNormalRanges, PatientResultsData } from "types/patient";

import { ResultRow } from "./components/resultRow";

const Unit = styled.div`
  ${typeScale.sm}

  font-weight: normal;
  color: ${(props) => props.theme.colours.bodyLight};

  ${({ theme }) => theme.breakpoints.up("md")} {
    ${typeScale.md}
  }
`;

export const labels = {
  date: "Date",
  time: "Time",
  wbc: "WBC",
  granulocytes: "Granulocytes",
};

export const ResultsTable: React.FC<{
  results?: Maybe<PatientResultsData>;
  confirmatoryThreshold?: Maybe<number>;
  patientNormalRanges?: Maybe<PatientNormalRanges>;
}> = ({ results, confirmatoryThreshold, patientNormalRanges }) => {
  return (
    <Table sticky>
      <thead data-testid="results-table-header">
        <tr>
          <th scope="col">{labels.date}</th>
          <th scope="col">{labels.time}</th>
          <th scope="col">
            {labels.wbc}
            <Unit>
              <UnitWBC normalRange={patientNormalRanges?.wbcRange} />
            </Unit>
          </th>
          <th scope="col">
            {labels.granulocytes}
            <Unit>
              <UnitGranulocyte normalRange={patientNormalRanges?.granulocyteRange} />
            </Unit>
          </th>
        </tr>
      </thead>
      <tbody>
        {results?.map((result) => (
          <ResultRow key={result.id} result={result} confirmatoryThreshold={confirmatoryThreshold} />
        ))}
      </tbody>
    </Table>
  );
};
